import { render } from "./TourTableRiver.vue?vue&type=template&id=a0d04e46&scoped=true"
import script from "./TourTableRiver.vue?vue&type=script&lang=js"
export * from "./TourTableRiver.vue?vue&type=script&lang=js"

import "./TourTableRiver.vue?vue&type=style&index=0&id=a0d04e46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d04e46"]])

export default __exports__